import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import { getCoordsDataType } from './shader_compiler';
export var GatherNDProgram = function GatherNDProgram(sliceDim, strides, shape) {
  _classCallCheck(this, GatherNDProgram);

  this.sliceDim = sliceDim;
  this.strides = strides;
  this.variableNames = ['x', 'indices'];
  this.outputShape = shape;
  var stridesType = getCoordsDataType(strides.length);
  var dtype = getCoordsDataType(shape.length);
  var strideString = this.sliceDim > 1 ? 'strides[j]' : 'strides';
  this.userCode = "\n        ".concat(stridesType, " strides = ").concat(stridesType, "(").concat(this.strides, ");\n         void main() {\n          ").concat(dtype, " coords = getOutputCoords();\n          int flattenIndex = 0;\n          for (int j = 0; j < ").concat(this.sliceDim, "; j++) {\n            int index = round(getIndices(coords[0], j));\n            flattenIndex += index * ").concat(strideString, ";\n          }\n          setOutput(getX(flattenIndex, coords[1]));\n        }\n      ");
};